import Button from "./global/Button";
import Logo from "../assets/Logo.svg";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "../App.css";
import { CrossIcon, Hemburger } from "../assets/SvgIcons";
import OwnLanguage from "./global/OwnLanguage";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";
import { bookingUrlWithFromRsSite } from "../utils/bookingFromSiteUrl";

const BOOKING_URL = process.env.REACT_APP_BOOKING_URL || "https://booking.rogersounds.com";

function CollapsibleExample() {
  const { t } = useTranslation();
  const { isLoggedIn, toggleAuthModal } = useAuth();
  const [isActive, setIsActive] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleScrollToSection = (sectionId) => {
    if (location.pathname !== "/") {
      navigate("/", { replace: true });
    }

    setTimeout(() => {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }, 0);
  };
  const navigateMobileNavbar = (section) =>{
    handleScrollToSection(section);
    setIsActive(!isActive);
  };

  return (
    <>
      <div className="Navbar-main-container">
        {/* Desktop Navbar */}
        <Navbar
          collapseOnSelect
          expand="lg"
          className="w-100 navbar first-navbar"
        >
          <Container className="w-100 px-0">
            <Navbar.Brand href="/" className="nav-logo navbar-logo">
              <img src={Logo} alt="Logo" />
            </Navbar.Brand>
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="me-auto">
                <Nav.Link onClick={() => handleScrollToSection("services")}>
                {t("Services")}
                </Nav.Link>
                <Nav.Link onClick={() => handleScrollToSection("aboutStudio")}>
                {t("About studio")}
                </Nav.Link>
                <Nav.Link onClick={() => handleScrollToSection("Team")}>
                {t("Team")}
                </Nav.Link>
                <Nav.Link onClick={() => handleScrollToSection("Equipment")}>
                {t("Equipment")}
                </Nav.Link>
                <Nav.Link onClick={() => handleScrollToSection("Portfolio")}>
                {t("Portfolio")}
                </Nav.Link>
                <Nav.Link onClick={() => handleScrollToSection("Contacts")}>
                {t("Contacts")}
                </Nav.Link>
              </Nav>
              <OwnLanguage />
              <Nav className="d-flex align-items-center gap-2">
                {!isLoggedIn ? (
                  <button
                    type="button"
                    className="main-btn"
                    onClick={() => toggleAuthModal(true, "login")}
                  >
                    Увійти
                  </button>
                ) : (
                  <a href={`${BOOKING_URL}/profile`} className="main-btn text-decoration-none">
                    Профіль
                  </a>
                )}
                <Nav.Link href={bookingUrlWithFromRsSite()} className="px-0">
                  <Button path={bookingUrlWithFromRsSite()} />
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        {/* Mobile Navbar */}
        <div className="mobile-navbar">
          <div className="d-flex justify-content-between align-items-center">
            <div className="pt-1 pb-2">
              <a href="/" className="mobile-navbar-logo">
                <img src={Logo} alt="Logo" />
              </a>
            </div>
            <div className="d-flex align-items-center gap-2">
              <button
                type="button"
                className="main-btn mobile-book-btn"
                onClick={() => (window.location.href = bookingUrlWithFromRsSite())}
              >
                {t("Book")}
              </button>
              <div className="mobile-icon" onClick={() => setIsActive(!isActive)}>
                {isActive ? <CrossIcon /> : <Hemburger />}
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Submenu */}
        <div className={`mobile-submenu ${isActive ? "" : "active"}`}>
          <Nav className="mobile-nav-submenus">
            <div className="mobile-auth-section">
              {!isLoggedIn ? (
                <Nav.Link
                  onClick={() => {
                    toggleAuthModal(true, "login");
                    setIsActive(false);
                  }}
                  className="auth-mobile-link"
                >
                  Увійти
                </Nav.Link>
              ) : (
                <Nav.Link href={`${BOOKING_URL}/profile`} className="auth-mobile-link">
                  Профіль
                </Nav.Link>
              )}
            </div>
            <div className="mobile-nab-divider mobile-nav-divider-main" />
            <Nav.Link onClick={() => navigateMobileNavbar("services")}>
              {t("Services")}
            </Nav.Link>
            <div className="mobile-nab-divider"></div>
            <Nav.Link onClick={() => navigateMobileNavbar("aboutStudio")}>
              {t("About studio")}
            </Nav.Link>
            <div className="mobile-nab-divider"></div>
            <Nav.Link onClick={() => navigateMobileNavbar("Team")}>
              {t("Team")}
            </Nav.Link>
            <div className="mobile-nab-divider"></div>
            <Nav.Link onClick={() => navigateMobileNavbar("Equipment")}>
              {t("Equipment")}
            </Nav.Link>
            <div className="mobile-nab-divider"></div>
            <Nav.Link onClick={() => navigateMobileNavbar("Portfolio")}>
              {t("Portfolio")}
            </Nav.Link>
            <div className="mobile-nab-divider"></div>
            <Nav.Link onClick={() => navigateMobileNavbar("Contacts")}>
              {t("Contacts")}
            </Nav.Link>
          </Nav>
          <Nav className="mobile-nav-submenus mobile-nav-footer">
            <Nav.Link href="/privacy">{t("Privacy policy")}</Nav.Link>
            <div className="mobile-navbar-language">
              <OwnLanguage />
            </div>
            <p>©2022. All rights reserved. Roger Studio</p>
          </Nav>
        </div>
      </div>
    </>
  );
}

export default CollapsibleExample;
